"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _assertThisInitialized = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
var _defineProperty2 = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _TableHead = _interopRequireDefault(require("@material-ui/core/TableHead"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _TableHeadCell = _interopRequireDefault(require("./TableHeadCell"));
var _TableHeadRow = _interopRequireDefault(require("./TableHeadRow"));
var _TableSelectCell = _interopRequireDefault(require("./TableSelectCell"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var defaultHeadStyles = function defaultHeadStyles(theme) {
  return {
    main: {},
    responsiveStacked: _defineProperty2({}, theme.breakpoints.down('sm'), {
      display: 'none'
    }),
    responsiveSimple: _defineProperty2({}, theme.breakpoints.down('xs'), {
      display: 'none'
    })
  };
};
var TableHead = /*#__PURE__*/function (_react$default$Compon) {
  _inherits(TableHead, _react$default$Compon);
  function TableHead() {
    var _this;
    _classCallCheck(this, TableHead);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(TableHead).apply(this, arguments));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleToggleColumn", function (index) {
      _this.props.toggleSort(index);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleRowSelect", function () {
      _this.props.selectRowUpdate('head', null);
    });
    return _this;
  }
  _createClass(TableHead, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.handleHeadUpdateRef(this.handleUpdateCheck);
    }
  }, {
    key: "render",
    value: function render() {
      var _ref,
        _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        columns = _this$props.columns,
        count = _this$props.count,
        options = _this$props.options,
        data = _this$props.data,
        setCellRef = _this$props.setCellRef,
        selectedRows = _this$props.selectedRows,
        expandedRows = _this$props.expandedRows,
        _this$props$sortOrder = _this$props.sortOrder,
        sortOrder = _this$props$sortOrder === void 0 ? {} : _this$props$sortOrder,
        _this$props$component = _this$props.components,
        components = _this$props$component === void 0 ? {} : _this$props$component;
      var numSelected = selectedRows && selectedRows.data.length || 0;
      var isIndeterminate = numSelected > 0 && numSelected < count;
      var isChecked = numSelected > 0 && numSelected >= count;

      // When the disableToolbarSelect option is true, there can be
      // selected items that aren't visible, so we need to be more
      // precise when determining if the head checkbox should be checked.
      if (options.disableToolbarSelect === true || options.selectToolbarPlacement === 'none' || options.selectToolbarPlacement === 'above') {
        if (isChecked) {
          for (var ii = 0; ii < data.length; ii++) {
            if (!selectedRows.lookup[data[ii].dataIndex]) {
              isChecked = false;
              isIndeterminate = true;
              break;
            }
          }
        } else if (numSelected > count) {
          isIndeterminate = true;
        }
      }
      return /*#__PURE__*/_react.default.createElement(_TableHead.default, {
        className: (0, _classnames.default)((_ref = {}, _defineProperty2(_ref, classes.responsiveStacked, options.responsive === 'vertical' || options.responsive === 'stacked' || options.responsive === 'stackedFullWidth'), _defineProperty2(_ref, classes.responsiveSimple, options.responsive === 'simple'), _defineProperty2(_ref, classes.main, true), _ref))
      }, /*#__PURE__*/_react.default.createElement(_TableHeadRow.default, null, options.selectCellPostion === 'left' && /*#__PURE__*/_react.default.createElement(_TableSelectCell.default, {
        ref: function ref(el) {
          return setCellRef(0, (0, _reactDom.findDOMNode)(el));
        },
        onChange: this.handleRowSelect.bind(null),
        indeterminate: isIndeterminate,
        checked: isChecked,
        isHeaderCell: true,
        expandedRows: expandedRows,
        expandableRowsHeader: options.expandableRowsHeader,
        expandableOn: options.expandableRows,
        selectableOn: options.selectableRows,
        fixedHeader: options.fixedHeader,
        fixedSelectColumn: options.fixedSelectColumn,
        selectableRowsHeader: options.selectableRowsHeader,
        onExpand: this.props.toggleAllExpandableRows,
        isRowSelectable: true
      }), columns.map(function (column, index) {
        return column.display === 'true' && (column.customHeadRender ? column.customHeadRender(_objectSpread({
          index: index
        }, column), _this2.handleToggleColumn, sortOrder) : /*#__PURE__*/_react.default.createElement(_TableHeadCell.default, {
          cellHeaderProps: columns[index].setCellHeaderProps ? columns[index].setCellHeaderProps(_objectSpread({
            index: index
          }, column)) : {},
          key: index,
          index: index,
          type: "cell",
          ref: function ref(el) {
            return setCellRef(index + 1, (0, _reactDom.findDOMNode)(el));
          },
          sort: column.sort,
          sortDirection: column.name === sortOrder.name ? sortOrder.direction : 'none',
          toggleSort: _this2.handleToggleColumn,
          hint: column.hint,
          print: column.print,
          firstIcon: column.firstIcon,
          lastIcon: column.lastIcon,
          options: options,
          column: column,
          components: components
        }, column.label));
      }), options.selectCellPostion === 'right' && /*#__PURE__*/_react.default.createElement(_TableSelectCell.default, {
        ref: function ref(el) {
          return setCellRef(0, (0, _reactDom.findDOMNode)(el));
        },
        onChange: this.handleRowSelect.bind(null),
        indeterminate: isIndeterminate,
        checked: isChecked,
        isHeaderCell: true,
        expandedRows: expandedRows,
        expandableRowsHeader: options.expandableRowsHeader,
        expandableOn: options.expandableRows,
        selectableOn: options.selectableRows,
        fixedHeader: options.fixedHeader,
        fixedSelectColumn: options.fixedSelectColumn,
        selectableRowsHeader: options.selectableRowsHeader,
        onExpand: this.props.toggleAllExpandableRows,
        isRowSelectable: true
      })));
    }
  }]);
  return TableHead;
}(_react.default.Component);
var _default = (0, _styles.withStyles)(defaultHeadStyles, {
  name: 'MUIDataTableHead'
})(TableHead);
exports.default = _default;